module.exports = __webpack_public_path__ + "static/media/martina-rusch.e8fe7acb.jpg";